import React, { createContext, useState } from 'react'

export interface Tools {
  pageName?: string
  userEmail?: string
  panels?: any
  events?: any
  poi?: any
  logs?: any
  groups?: any
  tags?: any
  tickers?: any
  tickersEmergenza?: any
  banners?: any
  splashscreen?: any
  city?: string
  fermate?: any
  status?: any
  setPageName?: (...args) => void
  setUserEmail?: (...args) => void
  changePageName?: (...args) => void
  setPanels?:any
  setEvents?:any
  setPoi?:any
  setLogs?:any
  setGroups?:any
  setTags?:any
  setTickers?:any
  setTickersEmergenza?:any
  setBanners?:any
  setSplashscreen?:any
  setCity?: (...args) => void
  setFermate?:any
  setStatus?:any
}

const defaultTools: Tools = {
  pageName: '',
  userEmail: '',
  panels: [],
  events: [],
  poi: [],
  logs: [],
  groups: [],
  tags: [],
  tickers: [],
  tickersEmergenza: [],
  banners: [],
  splashscreen: [],
  city: '',
  fermate: [],
  status: [],
  changePageName: () => {}
}

export const AppAuthGlobalVariables = createContext(defaultTools)

const AppAuthContext:any = ({children}: any) => {
  const regex = /[-/]/g;

  const [pageName, setPageName] = useState('');
  const [userEmail, setUserEmail] = useState('');

  const [panels, setPanels] = useState([]);
  const [events, setEvents] = useState([]);
  const [poi, setPoi] = useState([]);
  const [logs, setLogs] = useState([]);
  const [groups, setGroups] = useState([]);
  const [tags, setTags] = useState([]);
  const [tickers, setTickers] = useState([]);
  const [tickersEmergenza, setTickersEmergenza] = useState([]);
  const [banners, setBanners] = useState([]);
  const [splashscreen, setSplashscreen] = useState('');
  const [city, setCity] = useState('');
  const [fermate, setFermate] = useState([]);
  const [status, setStatus] = useState([]);
  
  const changePageName = (params:string) => {
    const processedPage = params.replaceAll(regex, ' ');
    setPageName(processedPage);
  }

  const availableTools: Tools = {
    pageName,
    userEmail,
    panels,
    events,
    poi,
    logs,
    groups,
    tags,
    tickers,
    tickersEmergenza,
    banners,
    splashscreen,
    city,
    fermate,
    status,
    setPageName,
    setUserEmail,
    changePageName,
    setPanels,
    setEvents,
    setPoi,
    setLogs,
    setGroups,
    setTags,
    setTickers,
    setTickersEmergenza,
    setBanners,
    setSplashscreen,
    setCity,
    setFermate,
    setStatus
  }

  return (<AppAuthGlobalVariables.Provider value={availableTools}>{children}</AppAuthGlobalVariables.Provider>)
}

export default AppAuthContext;